import { predictExpenseCategory } from 'api/v2/AI';
import { useDebouncedSearchValue } from 'hooks/shared/useDebouncedSearchValue';
import useQuery from 'hooks/react-query/useQuery';

import { AICacheKeys } from 'types/cacheKeys.types';

type UsePredictCategoryProps = {
  searchValue: string;
  categoriesDict: Record<string, any>;
};

export const usePredictCategory = ({
  searchValue,
  categoriesDict,
}: UsePredictCategoryProps) => {
  const debouncedSearchValue = useDebouncedSearchValue(searchValue);

  const { data, isError } = useQuery(
    [AICacheKeys.PredictCategory, debouncedSearchValue],
    () => predictExpenseCategory(debouncedSearchValue),
    {
      enabled: debouncedSearchValue?.length > 2,
      select: (data) => data.data,
    },
  );

  const { category, predictedSearchText = '-', notDeductible } = data || {};
  const categoryObject = categoriesDict[category?.id];

  return {
    predictedSearchText,
    notDeductible,
    categoryName: categoryObject?.displayName || categoryObject?.title || '-',
    category: categoryObject,
    isError,
  };
};
